const titles = {
	currentCampaignsTitle: 'Probíhající kampaně',
	planedCampaignsTitle: 'Chystané kampaně',
};

const tables = {
	name: 'Název',
	channel: 'Kanál',
	validityDateFrom: 'Platnost od',
	validityDateTo: 'Platnost do',
	dateFromStart: 'Do začátku',
	days: 'dni',
};

const sidebar = {
	sidebarTitle: 'Dashboard',
	currentProduction: 'Aktuální produkce',
	actualReplacement: 'Aktuální náhrada',
	productionPlan: 'Plán produkce',
	planFulfillment: 'Plnění plánu produkce',
	addMatFulfillment: 'Vyřízenost',
	expectedReplacement: 'Plán náhrady',
	toAssign: 'K přidělení',
	toRelease: 'K uvolnění',
	todaysProduction: 'Vývoj produkce',
	timeToEndCampaign: 'Čas do konce kampaně',
	currency: 'Kč',
	report: 'Report kampaně',
	reportNotFound: 'Nebyla nalezena žádná data pro report',
};

export default {
	...titles,
	...tables,
	...sidebar,
};
